import { useState } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { sendSupport } from '../../actions/auth';
import { Input, Textarea } from '../../components/FormsControls/FormControls';
import styles from './Contact.module.css';

const SupportSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  message: Yup.string().required('Required'),
});

const Contact = (props) => {
  const { userData, sendSupport } = props;

  const [success, setSuccess] = useState(false);
  console.log('===userData', userData);

  const submitHandler = (supportData) => {
    sendSupport(supportData, () => {
      setSuccess(true);
    });
  };

  const renderContent = () => {
    if (success) {
      return (
        <div className={styles.thankYou}>
          <div className={styles.thanksTitle}>
            Thank you!
          </div>
          <div className={styles.thanksSubtitle}>
            Your request was sent. We will reply within 24h to your request.
          </div>
        </div>
      );
    }

    return (
      <Formik
        onSubmit={submitHandler}
        initialValues={{ name: userData?.name || '', email: userData?.email || '', message: '' }}
        validationSchema={SupportSchema}
      >
        {({ isValid, dirty }) => (
          <Form className={styles.form}>
            <Input
              className={styles.input}
              name="name"
              placeholder="Name"
            />
            <Input
              className={styles.input}
              name="email"
              placeholder="Email"
            />
            <Textarea
              className={cn(styles.input, styles.textarea)}
              name="message"
              placeholder="Type your request here..."
            />
            <button
              className="green-button"
              disabled={!isValid || !dirty}
            >
              Send Request
            </button>
          </Form>
        )}
      </Formik>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Link 
          className={'back-button'} 
          to="/" 
        />
        <div className={styles.title}>
          Support
        </div>
        <div className={styles.whiteField}>
          <div className={styles.formTitle}>
            Need Help?
          </div>
          <div className={styles.formSubtitle}>
            If you have any questions, issues or need assistance, feel free to reach out to us. 
          </div>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData?.user,
});

const mapDispatchToProps = {
  sendSupport,
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
